import React, { useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import VideoIcon from '@wix/da-ds/pkg/Icons/24x24/AddVideo';
import { ThemeOverride, ThemeOptions, } from '@wix/da-react-context/pkg/ThemeContext';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import TierBadgeWithTooltip from '../../../../TierBadgeWithTooltip';
import { useDeviationViewContext } from '../../../../Context';
import { getDeviationType, isDeviationPixelArt, isFileLargerThanSize, scaleToSize, } from '../../../_helpers';
import { DeviationTypes } from '../../../../types/deviation';
import { usePrimaryTier } from '../../../../Tier/PrimaryTierContext';
import { useSubscriptionTier } from '../../../../utils/hooks/useSubscriptionTier';
import MediaService from '../../../../utils/DeviationMediaService';
import SubscribeButton from '../../../../Button/SubscribeButton';
import ImageContent from '../../Image/ImageContent';
import ContentShadow from '../ContentShadow';
import ConditionalWrapper from '../../../../ConditionalWrapper';
import { formatPrice } from '../../../TierProductCardDumb/utils';
import s from './SubPaywall.scss';
var SubPaywall = function (_a) {
    var _b, _c, _d;
    var width = _a.width, height = _a.height, deviation = _a.deviation, _e = _a.showImage, showImage = _e === void 0 ? false : _e, _f = _a.isStatusArtStage, isStatusArtStage = _f === void 0 ? false : _f, className = _a.className;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var isFullscreen = useDeviationViewContext().isFullscreen;
    var tier = usePrimaryTier(deviation);
    var isSubscribedButBlocked = useSubscriptionTier(deviation).isSubscribedButBlocked;
    var zoomedFile = MediaService.getLargestFullview(deviation);
    var isHuge = !!zoomedFile && isFileLargerThanSize(zoomedFile, width, height);
    var file = isHuge
        ? MediaService.getFullviewForSize(deviation, width, height)
        : zoomedFile;
    if (!file || !tier) {
        return null;
    }
    var size = scaleToSize(file, { width: width, height: height });
    var isPixel = isDeviationPixelArt(deviation);
    var isFilm = getDeviationType(deviation) === DeviationTypes.FILM;
    var bodylocaleKey = getBodyLocaleKey(isMobile, isSubscribedButBlocked);
    var bodyText = t(bodylocaleKey, {
        username: (_b = deviation === null || deviation === void 0 ? void 0 : deviation.author) === null || _b === void 0 ? void 0 : _b.username,
        price: formatPrice((_c = tier.tier) === null || _c === void 0 ? void 0 : _c.dollarPrice),
    });
    return (React.createElement("div", { className: classNames(s['root'], !showImage && s['no-image'], isStatusArtStage && s['status'], isFullscreen && s['fullscreen'], className), style: { width: width, height: height } },
        showImage && (React.createElement(ContentShadow, { content: file, containerSize: { width: size === null || size === void 0 ? void 0 : size.width, height: size === null || size === void 0 ? void 0 : size.height }, useSmallStage: true, className: s['overlay'] },
            React.createElement("div", null,
                React.createElement(ImageContent, { key: file.src, width: size === null || size === void 0 ? void 0 : size.width, height: size === null || size === void 0 ? void 0 : size.height, file: file, alt: (_d = deviation.title) !== null && _d !== void 0 ? _d : '', isPixel: isPixel, canZoom: false, onZoom: function () { } })),
            isFilm && React.createElement(VideoIcon, { className: s['video-icon'] }))),
        React.createElement("div", { className: s['centered'], style: size },
            React.createElement(ConditionalWrapper, { condition: showImage, wrap: function (children) { return (React.createElement(ThemeOverride, { theme: ThemeOptions.DARK }, children)); } },
                React.createElement(TierBadgeWithTooltip, { size: 40, isLocked: true, className: s['icon'] })),
            React.createElement("div", { className: s['title'] }, t(isSubscribedButBlocked
                ? 'deviationview.subpaywall.title.subscribedButBlocked'
                : 'deviationview.subpaywall.title')),
            React.createElement("div", { className: s['main'] }, bodyText),
            !isSubscribedButBlocked && (React.createElement(BiLoggerContextProvider, { value: { referral_info: ReferralType.CONTENT_PAGE } },
                React.createElement(SubscribeButton, { tier: tier }))))));
};
SubPaywall.displayName = 'SubPaywall';
export default SubPaywall;
function getBodyLocaleKey(isMobile, isSubscribedButBlocked) {
    if (isMobile === void 0) { isMobile = false; }
    if (isSubscribedButBlocked === void 0) { isSubscribedButBlocked = false; }
    var bodyTextlocaleKey = 'deviationview.subpaywall.body';
    if (isSubscribedButBlocked) {
        // deviationview.subpaywall.body.subscribedButBlocked
        bodyTextlocaleKey += '.subscribedButBlocked';
    }
    if (isMobile) {
        // deviationview.subpaywall.body.mobile
        // deviationview.subpaywall.body.subscribedButBlocked.mobile
        bodyTextlocaleKey += '.mobile';
    }
    return bodyTextlocaleKey;
}
//# sourceMappingURL=SubPaywall.js.map